import { z } from 'zod';

export const SortableObjectSchema = z.object({
  index: z.number().nonnegative(),
  items: z.array(z.string()),
  containerId: z.string(),
});
